//helpers
import { ApiHelper } from 'shared/helpers/api';

//constants
import { getUrl, ROUTES } from 'shared/api/urls';

export const fetchListingData = async (
  payload: Record<string, string>,
  headers: Record<string, string>
) => {
  const baseUrl = getUrl(
    payload.offer_id || payload.coupon_offer_id ? ROUTES.LISTING_OFFER : ROUTES.LISTING
  );
  const query = new URLSearchParams(payload).toString();
  return await ApiHelper(`${baseUrl}?${query}`, { headers }).then(async (response) => {
    if (response.ok === false) return Promise.reject({ status: response.status, data: response });

    return await response.json();
  });
};
